import Marquee from "react-fast-marquee";

export default function EditorialMarquee() {
  const items = [
    "Hair", "Nails", "Facials", "Waxing", "Hell's Kitchen", "Balayage",
    "HydraFacial", "Gel", "Brows", "NYC", "Color Correction", "Lash Lift",
  ];
  return (
    <div className="border-y border-border bg-background py-6" aria-hidden="true" data-testid="editorial-marquee">
      <Marquee speed={38} gradient={false} pauseOnHover>
        {items.map((t, i) => (
          <span key={i} className="mx-10 inline-flex items-center gap-10 font-display italic text-3xl md:text-5xl text-foreground/85">
            {t}
            <span className="text-wine not-italic">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
